"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GradientArea = void 0;
const react_1 = __importStar(require("react"));
const ColorPicker_module_css_1 = __importDefault(require("../public/ColorPicker.module.css"));
const GradientArea = (props) => {
    const { color } = props;
    const updateColorFromGradient = (event) => {
        if (color.colorGradientRef && color.colorGradientRef.current) {
            const gradientArea = color.colorGradientRef.current;
            let x = event.clientX - gradientArea.getBoundingClientRect().left;
            let y = event.clientY - gradientArea.getBoundingClientRect().top;
            // The width and height should be the same
            const size = color.colorGradientRef.current.clientWidth;
            if (x > size)
                x = size;
            if (y > size)
                y = size;
            if (x < 0)
                x = 0;
            if (y < 0)
                y = 0;
            const value = 100 - (y * 100 / size) | 0;
            const saturation = x * 100 / size | 0;
            color.setHSV(color.hue, saturation, value);
            color.updateRGBFromHSV();
            color.updateHexFromRGB();
            color.updateColorPickerCircle(x, y);
        }
    };
    const colorAreaClickHandler = (event) => {
        updateColorFromGradient(event);
    };
    (0, react_1.useEffect)(() => {
        // Updates all selector position based on the current color.
        // This is only called once when rendered.
        color.setAlphaSliderBackgroundColor();
        color.updateColorSelectors();
        color.updateAlphaSelector();
    }, []);
    const mouseMove = (event) => {
        updateColorFromGradient(event);
    };
    const mouseUp = (event) => {
        updateColorFromGradient(event);
        removeEventListener("mousemove", mouseMove);
        removeEventListener("mouseup", mouseUp);
    };
    const registerMouseEvents = (event) => {
        event.preventDefault();
        color.removeInputFocus();
        addEventListener("mousemove", mouseMove);
        addEventListener("mouseup", mouseUp);
    };
    return (react_1.default.createElement("div", { ref: color.colorGradientRef, className: ColorPicker_module_css_1.default.color_picker_area, style: { backgroundColor: "red" }, onClick: colorAreaClickHandler, onMouseDown: registerMouseEvents, draggable: false, "data-cy": "ColorPickerGradientArea" },
        react_1.default.createElement("div", { className: ColorPicker_module_css_1.default.color_picker_area_white_gradient },
            react_1.default.createElement("div", { className: ColorPicker_module_css_1.default.color_picker_area_black_gradient },
                react_1.default.createElement("div", { ref: color.colorGradientCircleRef, className: ColorPicker_module_css_1.default.color_picker_circle, style: { left: "155px", top: "-5px" } })))));
};
exports.GradientArea = GradientArea;
